import ResourceSavingImage from '../images/hands.png';
import PublicizeImage from '../images/megaphone.png';
import PRBoostImage from '../images/rocket.png';

export const useful = [
  {
    id: 1,
    title: 'Resource saving',
    subTitle: 'Delegate tasks for free and get results that can be used in your future work.',
    image: ResourceSavingImage,
    alt: 'hands exchanging resources',
  },
  {
    id: 2,
    title: 'Publicize',
    subTitle:
      'We take pride in the real-world value of the tasks that our students perform and we share them in all available channels.',
    image: PublicizeImage,
    alt: 'megaphone and media marketing',
  },
  {
    id: 3,
    title: 'PR boost',
    subTitle:
      'This will increase the visibility of the company among job seekers and attract those who share the values of your company.',
    image: PRBoostImage,
    alt: 'rocket ship',
  },
];

export default useful;
